<template>
  <el-dialog :model-value="localVisible" width="60%" @close="onClose" class="cart-dialog">

    <template #header>
      <span class="section-title" style="margin: 0;">{{ $t('product.cart.title') }}</span>
    </template>

    <div v-if="cart.length === 0">
      <el-empty :description="$t('product.cart.empty')" />
    </div>

    <div v-else>
      <el-scrollbar :height="scrollHeight">
        <el-table :data="cart" border @selection-change="handleSelectionChange" class="cart-table">
          <el-table-column type="selection" width="55" />
          <el-table-column prop="productCode" :label="$t('product.cart.productNo')" min-width="120"></el-table-column>
          <el-table-column prop="name" :label="$t('product.cart.name')" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="prity" :label="$t('product.cart.purity')" width="120">
            <template #default="scope">
              {{ scope.row.prity || $t('product.page.consultService') }}
            </template>
          </el-table-column>
          <el-table-column prop="quantity" :label="$t('product.cart.quantity')" width="150">
            <template #default="scope">
              <el-input-number v-model="scope.row.quantity" :min="1" size="small"
                @change="syncQuantity(scope.row)" />
            </template>
          </el-table-column>
          <el-table-column :label="$t('product.cart.operation')" width="160">
            <template #default="scope">
              <el-button text type="primary" @click="viewDetails(scope.row)">{{ $t('product.cart.details') }}</el-button>
              <el-button text type="danger" @click="removeFromCart(scope.row)">{{ $t('product.cart.remove') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>

      <el-divider></el-divider>

      <div class="order-actions">
        <div class="order-buttons">
          <el-button text type="danger" @click="clearCart">{{ $t('product.cart.clearCart') }}</el-button>
        </div>
        <div class="cart-summary">
          <span class="cart-summary-label">{{ $t('product.cart.selectedCount', { count: selectedRows.length }) }}</span>
          <span class="total-num">¥{{ calculateTotalPrice() }}</span>
          <span class="cart-summary-tip">{{ $t('product.cart.priceTip') }}</span>
          <el-button type="primary" size="large" @click="checkout" :disabled="selectedRows.length === 0">
            {{ $t('product.cart.checkout') }}
          </el-button>
        </div>
      </div>
    </div>

    <!-- 产品详情 -->
    <el-dialog :model-value="cartVisible" width="52%" @close="cloeseDetails" append-to-body>
      <template #header>
        <span class="section-title" style="margin: 0;">{{ $t('product.cart.productDetails') }}</span>
      </template>
      <el-card shadow="never" v-if="selectedProduct">
        <el-descriptions :column="2" border>
          <el-descriptions-item :label="$t('product.attr.name')" v-if="selectedProduct.name">{{ selectedProduct.name }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.brand')" v-if="selectedProduct.brand">{{ selectedProduct.brand }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.productSn')" v-if="selectedProduct.productCode">{{ selectedProduct.productCode }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.classType')" v-if="selectedProduct.classtype">{{ selectedProduct.classtype }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.englishName')" v-if="selectedProduct.englistname">{{ selectedProduct.englistname }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.specifications')" v-if="selectedProduct.specifications">{{ selectedProduct.specifications }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.catalogId')" v-if="selectedProduct.catalogid">{{ selectedProduct.catalogid }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.cas')" v-if="selectedProduct.cas">{{ selectedProduct.cas }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.mdl')" v-if="selectedProduct.mdl">{{ selectedProduct.mdl }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.molecularFormula')" v-if="selectedProduct.molecularformula">{{ selectedProduct.molecularformula }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.molecularWeight')" v-if="selectedProduct.molecularweight">{{ selectedProduct.molecularweight }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.purity')" v-if="selectedProduct.purity">{{ selectedProduct.purity || $t('product.page.consultService') }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.ranks')" v-if="selectedProduct.ranks">{{ selectedProduct.ranks }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.storageCondition')" v-if="selectedProduct.storagecondition">{{ selectedProduct.storagecondition }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.fusingPoint')" v-if="selectedProduct.fusingpoint">{{ selectedProduct.fusingpoint }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.flashPoint')" v-if="selectedProduct.flashpoint">{{ selectedProduct.flashpoint }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.boilingPoint')" v-if="selectedProduct.boilingpoint">{{ selectedProduct.boilingpoint }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.density')" v-if="selectedProduct.density">{{ selectedProduct.density }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.refractiveIndex')" v-if="selectedProduct.refractiveindex">{{ selectedProduct.refractiveindex }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.packing')" v-if="selectedProduct.packing">{{ selectedProduct.packing }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.characters')" v-if="selectedProduct.characters">{{ selectedProduct.characters }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.steamDensity')" v-if="selectedProduct.steamdensity">{{ selectedProduct.steamdensity }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.waterSolubility')" v-if="selectedProduct.watersolubility">{{ selectedProduct.watersolubility }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.application')" v-if="selectedProduct.applicationrotation">{{ selectedProduct.applicationrotation }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.opticalActivity')" v-if="selectedProduct.opticalactivity">{{ selectedProduct.opticalactivity }}</el-descriptions-item>
          <el-descriptions-item label="WGK Germany" v-if="selectedProduct.wgkgermany">{{ selectedProduct.wgkgermany }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.dangerousGoodsSigns')" v-if="selectedProduct.dangerousgoodssigns">{{ selectedProduct.dangerousgoodssigns }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.safetyInstructions')" v-if="selectedProduct.safetyinstructions">{{ selectedProduct.safetyinstructions }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.packagingGrade')" v-if="selectedProduct.packaginggrade">{{ selectedProduct.packaginggrade }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.transportCode')" v-if="selectedProduct.dangerousgoodstransportationcode">{{ selectedProduct.dangerousgoodstransportationcode }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.hazardCode')" v-if="selectedProduct.hazardcategorycode">{{ selectedProduct.hazardcategorycode }}</el-descriptions-item>
          <el-descriptions-item :label="$t('product.attr.stock')" v-if="selectedProduct.stock">{{ selectedProduct.stock }}</el-descriptions-item>
        </el-descriptions>
      </el-card>
    </el-dialog>
  </el-dialog>
</template>


<script>
import { useCartStore } from "../../store/cartStore";
import { watchEffect } from "vue";
import { useI18n } from 'vue-i18n';
export default {
  name: "ProductCart",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localVisible: this.visible,
      selectedRows: [],
      selectedProduct: null,
      expandedRow: null,
      cartVisible: false,
      scrollHeight: '400px',
    };
  },
  watch: {
    visible(newVal) {
      this.localVisible = newVal;
      if (newVal) this.updateScrollHeight();
    },
    cart: {
      handler() {
        this.updateScrollHeight();
      },
      deep: true,
    },
  },
  mounted() {
    this.updateScrollHeight();
    window.addEventListener('resize', this.updateScrollHeight);
    window.addEventListener('error', (e) => {
      if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
        e.stopImmediatePropagation();
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateScrollHeight);
  },
  methods: {
    updateScrollHeight() {
      const rowHeight = 60;
      const overhead = 60;
      const byContent = this.cart.length * rowHeight + overhead;
      const byViewport = window.innerHeight * 0.5;
      const h = Math.min(byContent, byViewport);
      this.scrollHeight = Math.max(h, 200) + 'px';
    },
    handleSelectionChange(selected) {
      this.selectedRows = selected;
    },
    onClose() {
      this.$emit("update:visible", false);
    },
    checkout() {
      localStorage.setItem("selectedRows", JSON.stringify(this.selectedRows));
      if (this.selectedRows.length > 0) {
        this.$router.push({
          name: "Order",
          state: { selectedRows: this.selectedRows },
        });
      } else {
        this.$message.warning(this.$t('product.cart.selectMin'));
      }
    },
    toggleDetails(row) {
      if (this.expandedRow === row) {
        this.expandedRow = null;
      } else {
        this.expandedRow = row;
      }
    },
    viewDetails(detils) {
      this.selectedProduct = detils;
      this.cartVisible = true;
    },
    cloeseDetails() {
      this.selectedProduct = null;
      this.cartVisible = false;
    },
    getImagePath(structralType) {
      return `/static/picture/${structralType}`;
    },
  },
  setup() {
    const cartStore = useCartStore();
    const { t, locale } = useI18n();
    watchEffect(() => {
    });
    return {
      cart: cartStore.cart,
      totalPrice: cartStore.totalPrice,
      cartTotal: cartStore.cartTotal,
      clearCart: cartStore.clearCart,
      removeFromCart: cartStore.removeFromCart,
      increaseQuantity: cartStore.increaseQuantity,
      decreaseQuantity: cartStore.decreaseQuantity,
      calculateTotalPrice: cartStore.GettotalPrice,
      calculateSubtotal(item) {
        return (item.quantity * item.priceRMB).toFixed(2);
      },
      syncQuantity(item) {
        item
      },
      t,
      locale,
    };
  },
};
</script>

<style scoped>
/* ===== 表格 — 对齐 OrderDetailsPage 的 el-table 风格 ===== */
.cart-table :deep(th.el-table__cell) {
  background: #fafafa !important;
  color: #303133;
  font-weight: 600;
  font-size: 14px;
}

.cart-table :deep(td.el-table__cell) {
  font-size: 14px;
  color: #606266;
}

.cart-table :deep(.el-table__row:hover > td.el-table__cell) {
  background: #f5f7fa !important;
}

/* ===== 底部操作栏 — 对齐 OrderDetailsPage 的 order-actions ===== */
.order-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.order-buttons {
  display: flex;
  gap: 10px;
}

.cart-summary {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cart-summary-label {
  font-size: 14px;
  color: #606266;
}

.cart-summary-tip {
  font-size: 12px;
  color: #c0c4cc;
  margin-right: 12px;
}

.total-num {
  font-weight: 700;
  font-size: 20px;
  color: #f56c6c;
}

/* ===== 区块标题 — 对齐 OrderDetailsPage 的 section-title ===== */
.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #004f8e;
  padding-left: 12px;
  border-left: 4px solid #004f8e;
  line-height: 24px;
}
</style>
